
import { transports } from 'winston'
import { merge } from 'lodash'
import posthog from 'posthog-js'

// Winston levels mapped to the closest PostHog/OTel severity.
const LEVEL_MAP: Record<string, 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal'> = {
	error: 'error',
	warn: 'warn',
	info: 'info',
	http: 'info',
	verbose: 'debug',
	debug: 'debug',
	silly: 'trace'
}

/**
 * Winston transport that ships log records to PostHog Logs (OpenTelemetry-native)
 * via the posthog-js SDK. Records are batched by the SDK and sent to the
 * project's /i/v1/logs OTLP endpoint, automatically associated with the
 * identified PostHog person/session.
 */
export class PostHogTransport extends transports.Console {
	private defaultProps: Record<string, string | number | boolean | string[] | number[] | null | undefined> = {}

	constructor(private serviceName: string) {
		super({ silent: false })
	}

	setUserId(id?: string | number) {
		this.defaultProps = merge({}, this.defaultProps, { posthogDistinctId: id?.toString() })
	}

	get name() {
		return 'posthog'
	}

	set name(_value: string) {}

	log(info: any, callback: () => void) {
		try {
			const { level, message, timestamp: _timestamp, ...rest } = info
			posthog.captureLog({
				body: typeof message === 'string' ? message : JSON.stringify(message),
				level: LEVEL_MAP[level] || 'info',
				attributes: {
					'service.name': this.serviceName,
					...this.defaultProps,
					...rest
				}
			})
		} catch (_err) {
			// Do nothing — logging must never crash the app
		}
		callback?.()
		this.emit('logged', info)
	}
}
